import { render, staticRenderFns } from "./AddSuggestion.vue?vue&type=template&id=ef5e5be8&scoped=true&"
import script from "./AddSuggestion.vue?vue&type=script&lang=js&"
export * from "./AddSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./AddSuggestion.vue?vue&type=style&index=0&id=ef5e5be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5e5be8",
  null
  
)

export default component.exports